import * as DateService from '../utils/date';

class Goal {
  constructor(data) {
    this._id = data._id;
    this.createdAt = data.createdAt;
    this.name = data.name;
    this.status = data.status;
    this.user = data.user;

    // First, values coming from the DB are in different format.
    // Normalize them to a JS timestamp.
    // Then, all goals which don't have dueAt are the OLD ones from 2018.
    // Therefore, simply assume that their dueAt is 2018.
    this.dueAt = data.dueAt
      ? DateService.getTimestampFromDbDay(data.dueAt)
      : 1514764800000;
  }
}

export default Goal;



// WEBPACK FOOTER //
// ./src/goals/class.js